import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';
import Util from '@/common/utils/Util';
import { forEach } from 'lodash';
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from '@/common/constants/ConstCode';
import { HttpStatusCode } from 'axios';
const PHONE_AUTH_SESSION = 'phone_auth_session';
/**
 * 뱅크다이어리 관련 API Service
 * @class SignSvc
 */
class SignSvc extends ServiceExec {
  /**
   *  전문가회원 로그인
   *  @param id {string} 아이디
   *  @param password {string} 패스워드
   */
  signIn(params = {}) {
    const phoneAuthSession = store.getters['expert/getPhoneAuthSession'];
    const headers = phoneAuthSession ? { [PHONE_AUTH_SESSION]: phoneAuthSession } : {};
    return this.post(`/api/expert/login`, { ...params, clientType: 'EXPERT_PC' }, { headers }).then(
      async (response) => {
        const accessToken = response.headers[ACCESS_TOKEN_NAME];
        const refreshToken = response.headers[REFRESH_TOKEN_NAME];
        if (!Util.isEmpty(accessToken) && !Util.isEmpty(refreshToken)) {
          await store.dispatch('expert/signIn', { accessToken, refreshToken, data: response.data });
          store.commit('expert/setPhoneAuthSession', {
            phoneAuthSession: response.headers[PHONE_AUTH_SESSION] || phoneAuthSession
          });
          return { phoneAuthRequired: false, data: response.data };
        }
        store.commit('expert/setPhoneAuthSession', { phoneAuthSession: '' });
        return { phoneAuthRequired: true, data: response.data };
      }
    );
  }

  sendPhoneAuth(params) {
    return this.post('/api/expert/login/phone-auth/send', params).then((response) => response.data);
  }

  verifyPhoneAuth(params) {
    return this.post('/api/expert/login/phone-auth/verify', params).then(async (response) => {
      const accessToken = response.headers[ACCESS_TOKEN_NAME];
      const refreshToken = response.headers[REFRESH_TOKEN_NAME];
      if (Util.isEmpty(accessToken) || Util.isEmpty(refreshToken)) return false;
      await store.dispatch('expert/signIn', { accessToken, refreshToken, data: response.data });
      store.commit('expert/setPhoneAuthSession', {
        phoneAuthSession: response.headers[PHONE_AUTH_SESSION] || ''
      });
      return true;
    });
  }

  getPhoneAuthRecipients() {
    return this.get('/api/expert/phone-auth/recipients').then((response) => response.data);
  }

  beginPhoneAuthRecipient(params) {
    return this.post('/api/expert/phone-auth/recipients/challenge', params).then((response) => response.data);
  }

  verifyPhoneAuthRecipient(params) {
    return this.post('/api/expert/phone-auth/recipients/verify', params).then((response) => response.data);
  }

  deletePhoneAuthRecipient(recipientNo) {
    return this.ServiceExec.delete(`/api/expert/phone-auth/recipients/${recipientNo}`);
  }

  /**
   *  전문가회원 로그아웃
   *  @param Authorization {string} Authorization
   *  @param deviceId {string} deviceId
   */
  signOut(params = {}) {
    return this.get(`/api/expert/sign/out`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가회원 가입
   *  @param expertSignUpDTO {ExpertSignUpDTO} expertSignUpDTO
   */
  signUp(params = {}) {
    return this.post(`/api/expert/sign/up`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  전문가회원 아이디 찾기
   *  @param params {object} 본인인증 정보
   */
  getStringExpertId(params = {}) {
    return this.get(`/api/expert/find-id`, params)
      .then((response) => {
        return {
          status: response.status === HttpStatusCode.Ok,
          data: response.data
        };
      })
      .catch((response) => {
        return {
          status: false,
          data: response?.data
        };
      });
  }

  /**
   *  전문가회원 임시비밀번호 발송
   *  @param params {object} 아이디 및 본인인증 정보
   */
  getIntExpertTempPassword(params = {}) {
    return this.get(`/api/expert/find-password`, params)
      .then((response) => {
        return {
          status: response.status === HttpStatusCode.Ok,
          data: response.data
        };
      })
      .catch((response) => {
        return {
          status: false,
          data: response?.data
        };
      });
  }

  /**
   *  전문가회원 토큰 변경
   *  @param Authorization {string} Authorization
   */
  postMapChangeToken(params = {}) {
    let formData = new FormData();
    forEach(params, function (value, key) {
      formData.append(key, value);
    });
    return this.multiPost(`/api/expert/sign/postMapChangeToken`, formData).then((response) => {
      if (response.data.code !== 1) {
        return response.data;
      }
      let authToken = response.headers['bank_jwt_expert_token'];
      let data = response.data.entity;
      if (!Util.isEmpty(authToken))
        store.dispatch('expert/signIn', {
          accessToken: authToken,
          // data: JSON.stringify(data)
          data: data
        });
    });
  }

  /**
   *  ID 중복 체크
   *  @param id {string} id
   */
  getIntIdCnt(params = {}) {
    return this.get(`/api/expert/sign/getIntIdCnt`, params).then((response) => {
      return response.data;
    });
  }

  async renewAccessToken() {
    // const accessToken = this.accessToken;
    const refreshToken = this.refreshToken;

    if (!refreshToken) return false;

    const { status, headers } = await this.patch(`/api/expert/renew/access-token`, { refreshToken });
    if (status !== HttpStatusCode.Ok) return false;
    store.commit('expert/setAccessToken', headers[ACCESS_TOKEN_NAME]);
    store.commit('expert/setRefreshToken', headers[REFRESH_TOKEN_NAME]);
    return true;
  }
}
export default new SignSvc();
